"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var validate = require("validate.js");
validate.extend(validate.validators.datetime, {
    parse: function (value, options) {
        return +moment.utc(value);
    },
    format: function (value, options) {
        var format = options.dateOnly ? "DD-MM-YYYY" : "YYYY-MM-DD hh:mm:ss";
        return moment.utc(value).format(format);
    }
});
exports.mandatory = {
    presence: { allowEmpty: false }
};
exports.email = {
    presence: { allowEmpty: false },
    email: true
};
exports.radioButton = {
    presence: { allowEmpty: false },
    inclusion: ["yes", "no"]
};
exports.money = {
    presence: { allowEmpty: false },
    numericality: {
        greaterThan: 0
    }
};
exports.date = {
    datetime: {
        dateOnly: true,
        latest: moment.utc().year(3000),
        message: "Invalid date"
    },
    presence: { allowEmpty: false }
};
exports.checkDates = function (fromField, toField, json_data, rules) {
    if (json_data[fromField]) {
        rules[fromField] = __assign({}, exports.date);
        var datetime = exports.date.datetime;
        rules[toField] = {
            datetime: __assign(__assign({}, datetime), { earliest: moment(json_data[fromField]) })
        };
    }
    return rules;
};
exports.patterns = {
    phone: "^[0-9().+-]*$",
    money: "[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)",
    number: "[0-9]*$"
};
exports.masks = {
    ssn: "999999999",
    phone: "999999999999",
    number: "99999999999999999999"
};
exports.ssn = {
    format: {
        pattern: "[0-9]{9}",
        message: "Invalid number (must contain 9 digits)"
    }
};
//# sourceMappingURL=data:application/json;base64,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